import { dayjs } from '@server/shared/utils/date'

import { GetCouponDetailResponse, GetCouponResponse, GetRawCouponDetailResponse, RawCoupon } from '../dto'

export const couponResponseAdapter = (coupon: RawCoupon): GetCouponResponse => {
  return {
    couponId: coupon.coupon_id,
    templateId: coupon.template_id,
    displayStatus: coupon.display_status,
    title: coupon.title,
    discountType: coupon.discount_type,
    discountAmount: coupon.discount_amount,
    discountAmountMax: coupon.discount_amount_max,
    discountApplicationType: coupon.discount_application_type ?? 'RECURRING',
    discountedPaymentCount: coupon.discounted_payment_count ?? 1,
    utcUseStart: dayjs(coupon.utc_use_start).toISOString(),
    utcUseEnd: dayjs(coupon.utc_use_end).toISOString(),
    utcUsedAt: coupon.utc_used_at ? dayjs(coupon.utc_used_at).toISOString() : null,
    utcCreatedAt: dayjs(coupon.utc_created_at).toISOString(),
    utcDisplayUsedAt: coupon.utc_display_used_at ? dayjs(coupon.utc_display_used_at).toISOString() : null,
    description: coupon.description,
    paymentTypes: coupon.payment_types,
    applicable: coupon.applicable,
    promotionCode: coupon.promotion_code ?? null,
  } satisfies GetCouponResponse
}

export const getCouponDetailResponseAdapter = (coupon: GetRawCouponDetailResponse): GetCouponDetailResponse => {
  return {
    couponId: coupon.coupon_id,
    title: coupon.title,
    discountType: coupon.discount_type,
    discountAmount: coupon.discount_amount,
    displayStatus: coupon.display_status,
    discountAmountMax: coupon.discount_amount_max,
    discountApplicationType: coupon.discount_application_type ?? 'RECURRING',
    discountedPaymentCount: coupon.discounted_payment_count ?? 1,
    utcUseStart: dayjs(coupon.utc_use_start).toISOString(),
    utcUseEnd: dayjs(coupon.utc_use_end).toISOString(),
    utcDisplayUsedAt: coupon.utc_display_used_at ? dayjs(coupon.utc_display_used_at).toISOString() : null,
    utcCreatedAt: dayjs(coupon.utc_created_at).toISOString(),
    description: coupon.description,
    paymentTypes: coupon.payment_types,
    applyTargets: coupon.apply_targets.map((applyTarget) => ({
      langType: applyTarget.lang_type,
      lessonCountPerMonth: applyTarget.lesson_count_per_month,
      curriculumType: applyTarget.curriculum_type,
      lessonTime: applyTarget.lesson_time,
      lessonMonth: applyTarget.lesson_month,
      paymentType: applyTarget.payment_type,
      promotionType: applyTarget.promotion_type,
    })),
  }
}
